<template>
  <MainNavbar class="edu-fixed-nav" />
  <PaymentSuccess />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import PaymentSuccess from "../components/Payment/PaymentSuccess.vue";

export default defineComponent({
  name: "PaymentSuccessPage",
  components: {
    MainNavbar,
    PaymentSuccess,
  },
});
</script>
